'use client';

import { useState, useEffect } from 'react';
import SearchBar from './SearchBar';
import QuickLinks from './QuickLinks';
import FAQSection from './FAQSection';
import VideoTutorials from './VideoTutorials';
import SecurityCenter from './SecurityCenter';
import ContactSupport from './ContactSupport';
import CommunityForum from './CommunityForum';
import KnowledgeBase from './KnowledgeBase';

export default function SupportHubInteractive() {
  const [searchQuery, setSearchQuery] = useState('');
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-20">
          <div className="max-w-4xl mx-auto">
            <div className="h-12 bg-gray-200 rounded-lg animate-pulse mb-8" />
            <div className="h-64 bg-gray-200 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Search Bar Section */}
      <div className="bg-white py-12 -mt-20 pt-32 border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <SearchBar onSearch={handleSearch} />
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <QuickLinks />
      <KnowledgeBase />
      <FAQSection searchQuery={searchQuery} />
      <VideoTutorials />
      <SecurityCenter />
      <ContactSupport />
      <CommunityForum />
    </>
  );
}
